import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { ToastContainer, Bounce } from "react-toastify";

import { useLoginContext } from "./Login.context.tsx";

import bgImage from "../../assets/img/imagen.jpg";

const LoginViewUI: React.FC = () => {
  const { renderView } = useLoginContext();

  return (
    <Container fluid className="p-0 m-0 loginContainer">
      <Row className="h-100 g-0">
        <Col
          xs={12}
          md={6}
          className="p-5 hide-scrollbar d-flex "
          style={{
            overflowY: "auto",
            height: "100vh",
          }}
        >
          <div
            className="w-100"
            style={{
              margin: "auto 0",
              paddingTop: "2rem",
              paddingBottom: "2rem",
            }}
          >
            {renderView()}
          </div>
        </Col>

        <Col
          md={6}
          className="d-none d-md-block p-0"
          style={{
            backgroundImage: `url(${bgImage})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
            height: "100vh",
            position: "sticky",
            top: 0,
          }}
        />
      </Row>

      <ToastContainer
        position="bottom-right"
        autoClose={5000}
        hideProgressBar={false}
        closeOnClick={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        // Todo: cambiar
        theme="light"
        transition={Bounce}
      />
    </Container>
  );
};

export default LoginViewUI;
